import useBreakpointsStore from '~/stores/breakpoints';
import { breakpoints } from '~~/configs/breakpoints.config';
import type { IBreakpoint } from '~~/types/local_types';

export default defineNuxtPlugin(() => {
  const breakpointsStore = useBreakpointsStore();

  breakpoints.forEach((breakpoint: IBreakpoint) => {
    const _mediaQuery = window.matchMedia(
      `screen and (min-width: ${breakpoint.min}px)${breakpoint.max ? ` and (max-width: ${breakpoint.max}px)` : ''}`,
    );

    const changed = () => {
      if (_mediaQuery.matches && breakpointsStore.getCurrentBreakpoint?.name !== breakpoint.name) {
        breakpointsStore.setCurrentBreakpoint(breakpoint);
      }
    };

    // initial run
    changed();

    _mediaQuery.addEventListener('change', () => {
      changed();
    });
  });
});
